// extracted by mini-css-extract-plugin
export default {"PopupChoixRole":"PopupChoixRole_PopupChoixRole__zRfk8","ListeRoles":"PopupChoixRole_ListeRoles__9wJU2","Role":"PopupChoixRole_Role__6zBhn","Tarif":"PopupChoixRole_Tarif__F7qr9"};